import placeholder from '../assets/images/members_photos/placeholder.png'
import { Afonso_Dinis } from '../fotos';


const TeamListData = [
    {
    title: 'board',
    members: [
            { name: 'João Barbeiro', role: 'team-leader', imageSrc: placeholder
            },
            { name: 'Gonçalo Correia', role: 'technical-director', imageSrc: placeholder
            },
        ],
    },
    /* ///////Techincal//////// */
    {
    title: 'aerodynamics',
    members: [
            { name: 'Ricardo Cutileiro', role: 'dep-leader', imageSrc: placeholder
            },
            { name: 'Afonso Dinis', role: 'member', imageSrc: Afonso_Dinis
            },
            { name: 'Ângela Rodrigues', role: 'member', imageSrc: placeholder
            },
            { name: 'Beatriz Simões', role: 'member', imageSrc: placeholder
            },
            { name: 'Rafael Nunes', role: 'member', imageSrc: placeholder
            },
            { name: 'Francisco Rodrigues', role: 'member', imageSrc: placeholder
            },
        ],
    },
    {
    title: 'chassis&suspension',
    members: [
            { name: 'João Balbino', role: 'dep-leader', imageSrc: placeholder
            },
            { name: 'Frederico Firmino', role: 'member', imageSrc: placeholder
            },
            { name: 'Guilherme Santiago', role: 'member', imageSrc: placeholder
            },
            { name: 'Pedro Marques', role: 'member', imageSrc: placeholder
            },
            { name: 'Pedro Marçal', role: 'member', imageSrc: placeholder
            },
            { name: 'Tiago Soares', role: 'member', imageSrc: placeholder
            },
            { name: 'Miguel Amorim', role: 'member', imageSrc: placeholder
            },
            { name: 'Gonçalo Ribeiro', role: 'member', imageSrc: placeholder
            },
        ],
    },
    {
    title: 'electronics',
    members: [
            { name: 'Sergiu Nica', role: 'dep-leader', imageSrc: require('../assets/images/members_photos/board/sergiu.jpg')
            },
            { name: 'Miguel Caldeirinha', role: 'member', imageSrc: placeholder
            },
            { name: 'Daniel Sousa', role: 'member', imageSrc: placeholder
            },
            { name: 'Rodrigo Mendão', role: 'member', imageSrc: placeholder
            },
            { name: 'João Cruz', role: 'member', imageSrc: placeholder
            },
            { name: 'Frederico Inácio', role: 'member', imageSrc: placeholder
            },
            { name: 'Tiago Mega', role: 'member', imageSrc: placeholder
            },
            { name: 'Inês Monteiro', role: 'member', imageSrc: require('../assets/images/members_photos/electronics/ines_monteiro.jpg')
            },
            { name: 'Pedro Fernandes', role: 'member', imageSrc: placeholder
            },
        ],
    },
    {
    title: 'powertrain',
    members: [
            { name: 'Gonçalo Correia', role: 'dep-leader', imageSrc: placeholder
            },
            { name: 'Lourenço Vaz Tomé', role: 'member', imageSrc: placeholder
            },
            { name: 'João Vau', role: 'member', imageSrc: placeholder
            },
            { name: 'Tomás Rebelo', role: 'member', imageSrc: placeholder
            },
            { name: 'Henriqe Ferreira', role: 'member', imageSrc: placeholder
            },
            { name: 'João Castro', role: 'member', imageSrc: placeholder
            },
        ],
    },
    /* ///////BS//////// */
    {
    title: 'marketing',
    members: [
            { name: 'Joana Fernandes', role: 'dep-leader', imageSrc: placeholder
            },
            { name: 'Jaime Ferreira', role: 'member', imageSrc: require('../assets/images/members_photos/marketing/jaime_ferreira.jpg')
            },
            { name: 'Tomás Pereira', role: 'member', imageSrc: placeholder
            },
            { name: 'Catarina Matos', role: 'member', imageSrc: placeholder
            },
            { name: 'Tiago Fernandes', role: 'member', imageSrc: placeholder
            },
        ],
    },
    {
    title: 'corporate-relations',
    members: [
            { name: 'Miguel Durão', role: 'dep-leader', imageSrc: placeholder
            },
            { name: 'Tomás Sousa', role: 'member', imageSrc: require('../assets/images/members_photos/cr/tomas_sousa.jpg')
            },
            { name: 'Francisco Jorge', role: 'member', imageSrc: require('../assets/images/members_photos/cr/francisco_jorge.jpg')
            },
            { name: 'Emely Ballestros', role: 'member', imageSrc: placeholder
            },
        ],
    },
    {
    title: 'logistics',
    members: [
            { name: 'Diogo Algarvio' , role: 'member' , imageSrc: placeholder
            },
            { name: 'Mariana Ribeiro', role: 'member', imageSrc: placeholder
            },
        ],
    },
    {
    title: 'finances',
    members: [
            {name: 'Carolina Costa' , role: 'dep-leader' , imageSrc: require('../assets/images/members_photos/finances/carolina_costa.jpg'),
            },
        ],
    },
];
  
  export default TeamListData;